import { useQuery, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';


export const EXPRESS_SETUP_QUERY_KEY = 'EXPRESS_SETUP_BY_ID';
const useGetExpressSetupByIdQuery = (id: string) => {
  const queryClient = useQueryClient();

  const { data, isSuccess, isLoading, refetch } = useQuery(
    [EXPRESS_SETUP_QUERY_KEY, id],
    () => api.get(API_URL.EXPRESS_SETUPS_BY_ORGANIZATION_ID(id)),
    {
      enabled: !!id,
    }
  );

  const clearCache = () => {
    queryClient.removeQueries({
      queryKey: [EXPRESS_SETUP_QUERY_KEY, id],
    });
  };

  return {
    isLoading,
    isSuccess,
    data: data?.data,
    refetch,
    clearCache,
  };
};

export default useGetExpressSetupByIdQuery;
